import {z} from 'zod';

import i18n from '@dms/i18n';

const PASSWORD_MIN_LENGTH = 8;

export const zodPasswordValidation = z
  .string({required_error: i18n.t('general.notifications.errorPasswordsRequired')})
  .min(PASSWORD_MIN_LENGTH, i18n.t('general.notifications.errorPasswordsLength'))
  .regex(/^(?:[A-Z]|[a-z]|[0-9]|.){8,}$/, i18n.t('general.notifications.errorPasswordsFormat'))
  .regex(/[A-Z]/, i18n.t('general.notifications.errorPasswordsUppercase'))
  .regex(/[a-z]/, i18n.t('general.notifications.errorPasswordsLowercase'))
  .regex(/[0-9]/, i18n.t('general.notifications.errorPasswordsDigit'));
